import { BRAND_DESCRIPTOR, BRAND_NAME } from '../brand';

export function Wordmark() {
  return (
    <span className="wordmark__lockup" aria-hidden="true">
      <span className="wordmark__name">{BRAND_NAME}</span>
      <span className="wordmark__descriptor">{BRAND_DESCRIPTOR}</span>
    </span>
  );
}
